import { render, staticRenderFns } from "./edit-dam-sire-container.vue?vue&type=template&id=85f1ee6e&scoped=true&lang=pug"
import script from "./edit-dam-sire-container.js?vue&type=script&lang=js&external"
export * from "./edit-dam-sire-container.js?vue&type=script&lang=js&external"
import style0 from "./edit-dam-sire-container.vue?vue&type=style&index=0&id=85f1ee6e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85f1ee6e",
  null
  
)

export default component.exports